import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { User, DollarSign } from "lucide-react";
import type { DealWithStage } from "@/types/deal";
import { dealHasAttributedValue } from "@/lib/deals-funnel-filter";

interface DealCardProps {
  deal: DealWithStage;
  onClick: (deal: DealWithStage) => void;
}

function formatCurrency(value: number) {
  return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(value);
}

export function DealCard({ deal, onClick }: DealCardProps) {
  return (
    <Card
      className="cursor-pointer hover:shadow-md transition-shadow border group"
      onClick={() => onClick(deal)}
    >
      <CardContent className="p-3 space-y-2">
        <p className="font-medium text-sm truncate group-hover:text-primary transition-colors">{deal.title}</p>
        {deal.leads && (
          <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
            <User className="w-3 h-3" />
            <span className="truncate">{deal.leads.name}</span>
          </div>
        )}
        <div className="flex items-center justify-between">
          {dealHasAttributedValue(deal) ? (
            <div className="flex items-center gap-1 text-xs font-semibold">
              <DollarSign className="w-3 h-3 text-emerald-500" />
              {formatCurrency(Number(deal.amount))}
            </div>
          ) : (
            <span className="text-[10px] text-muted-foreground">Sem valor atribuído</span>
          )}
          {deal.probability != null && deal.probability > 0 && (
            <Badge variant="outline" className="text-[10px] px-1.5 py-0">
              {deal.probability}%
            </Badge>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
